import React from "react";
import styled from "styled-components";
import { IC } from "../../../../resources/Assets";

const OptionDiv = props => {
  const { data } = props;
  return (
    <Container>
      <ContentImg src={data.img} />
      <ContentText>{data.text}</ContentText>
    </Container>
  );
};

const Container = styled.div`
  /* width: 156px; */

  flex: 1 1 0;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 16px;
  border-radius: 6px;
  background-color: #f8f7fa;
`;

const ContentImg = styled.img`
  width: 32px;
  height: 32px;
  flex-grow: 0;
  padding: 6px 4.1px 6px 5px;
`;

const ContentText = styled.span`
  height: 24px;
  align-self: stretch;
  flex-grow: 0;
  font-family: Pretendard;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: -0.32px;
  text-align: center;
  color: #333;
`;

export default OptionDiv;
